export default "__VITE_ASSET__7d72a6a8__"